import { render, staticRenderFns } from "./feishuList.vue?vue&type=template&id=21ed5670&scoped=true"
import script from "./feishuList.vue?vue&type=script&lang=js"
export * from "./feishuList.vue?vue&type=script&lang=js"
import style0 from "./feishuList.vue?vue&type=style&index=0&id=21ed5670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed5670",
  null
  
)

export default component.exports